import { useMutation, useQueryClient } from '@tanstack/react-query';
import { rolloverAuditService } from '@/services/leave/rolloverAuditService';
import { leaveQueryKeys } from './queryKeys';
import { useToast } from '@/hooks/use-toast';

export const useRolloverMutations = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  const processAnnualRollover = useMutation({
    mutationFn: async (rolloverYear?: number) => {
      const result = await rolloverAuditService.executeRolloverWithAudit(rolloverYear);
      return result;
    },
    onMutate: () => {
      console.log('[useRolloverMutations] Starting manual rollover...');
    },
    onSuccess: (result) => {
      console.log('[useRolloverMutations] Rollover completed:', result);
      
      queryClient.invalidateQueries({ queryKey: leaveQueryKeys.balances() });
      queryClient.invalidateQueries({ queryKey: leaveQueryKeys.policies() });
      queryClient.invalidateQueries({ queryKey: ['rollover-audit-logs'] });
      
      toast({
        title: "Rollover Completed",
        description: `Processed ${result.result.processed_count} non-fixed balance(s) from ${result.result.rollover_year} to ${result.result.target_year}. ${result.result.skipped_count || 0} skipped, ${result.result.fixed_accrual_skipped || 0} fixed-accrual policies handled by cycle engine.`,
      });
    },
    onError: (error: Error) => {
      console.error('[useRolloverMutations] Rollover failed:', error);
      
      let errorMessage = "Failed to process rollover";
      if (error.message.includes('Unauthorized') || error.message.includes('insufficient_permissions')) {
        errorMessage = "You don't have permission to process rollovers";
      } else if (error.message.includes('Company ID required')) {
        errorMessage = "Company information not found. Please refresh and try again.";
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      toast({
        title: "Rollover Failed", 
        description: errorMessage,
        variant: "destructive",
      });
    },
  });

  return {
    processAnnualRollover,
    isProcessing: processAnnualRollover.isPending,
  };
};
